import { render, staticRenderFns } from "./ModalConsolidation.vue?vue&type=template&id=21208991&scoped=true"
import script from "./ModalConsolidation.vue?vue&type=script&lang=js"
export * from "./ModalConsolidation.vue?vue&type=script&lang=js"
import style0 from "./ModalConsolidation.vue?vue&type=style&index=0&id=21208991&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21208991",
  null
  
)

export default component.exports